import React from 'react'
import PrivateRoute from './PrivateRoute'

export default function TeacherRoute({
  component,
  ...rest
}) {
  return <PrivateRoute personRole="teacher" {...rest} component={component} />
}